import React from 'react'
import SignUpForm from './SignUpForm'

const SignUp = () => {
    return (
        <div className="text-left">
            <SignUpForm disableSubmit={false} />
        </div>
    )
}

export default SignUp
